module.exports = __webpack_public_path__ + "img/image_11.3124cc11.png";